import { createContext } from "react";

export const AppStoreContext = createContext(null);
export const AppStateStoreContext = createContext(null);